import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78fea013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "centre" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Mario Soundtrack Heardle", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_About = _resolveComponent("About")!
  const _component_Popup = _resolveComponent("Popup")!
  const _component_HowTo = _resolveComponent("HowTo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          title: "About",
          "aria-label": "About",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openAbout && _ctx.openAbout(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['far','circle-info'] })
        ]),
        _createElementVNode("button", {
          title: "How to play",
          "aria-label": "How to play",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openHowTo && _ctx.openHowTo(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['far','block-question'] })
        ])
      ])
    ]),
    _createVNode(_component_Popup, { ref: "aboutPopup" }, {
      default: _withCtx(() => [
        _createVNode(_component_About)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Popup, {
      ref: "howToPopup",
      onCloseOnce: _ctx.howToClosed
    }, {
      default: _withCtx(() => [
        _createVNode(_component_HowTo, { onClose: _ctx.closeHowTo }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["onCloseOnce"])
  ], 64))
}